import { Box, Typography } from '@mui/material';
import PropertiesTooltip from '~/components/Properties/PropertiesTooltip';
import StructureSetProperties from '~/components/Properties/StructureSetProperties';
import SelectableListItem from '~/components/SelectableListItem/SelectableListItem';
import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import { AvailableStructureSetView } from '~/domain/projections/views';
import { useStructureSetDetailView } from '~/hooks/domain/useStructureSetDetailView';
import { cutUID } from '~/utils/string';

type StructureSetItemProps = {
    structureSet: AvailableStructureSetView;
    isActive?: boolean;
    disabled?: boolean;
    onClick: () => void;
    onDelete?: () => void;
};

export default function StructureSetItem({
    structureSet,
    isActive = false,
    disabled,
    onClick,
    onDelete,
}: StructureSetItemProps) {
    const { displayName, sopInstanceUid, structureSetId } = structureSet;
    const detail = useStructureSetDetailView(structureSetId);

    return (
        <SelectableListItem
            isSelected={isActive}
            onClick={onClick}
            disabled={disabled ?? isActive}
            data-testid={`structureset-menu-item-${displayName}`}
        >
            <PropertiesTooltip
                title={
                    <StructureSetProperties
                        structureSet={structureSet}
                        onDelete={onDelete}
                    />
                }
            >
                <Box width="100%" overflow="hidden" display="grid">
                    <Box
                        alignItems="center"
                        display="grid"
                        gridTemplateColumns="1fr auto"
                        gap={1}
                    >
                        <Typography
                            color={
                                isActive || isActive === undefined
                                    ? 'text.primary'
                                    : 'text.secondary'
                            }
                            fontSize={12}
                            noWrap
                        >
                            <SensitiveInfoTypography>
                                {displayName}
                            </SensitiveInfoTypography>
                        </Typography>
                        {detail && (
                            <Typography
                                fontSize={10}
                                color="text.secondary"
                                flexShrink={0}
                            >
                                {detail.numberOfStructures} ROIs
                            </Typography>
                        )}
                    </Box>
                    <Box
                        display="grid"
                        gridTemplateColumns="1fr auto"
                        alignItems="center"
                        gap={1}
                    >
                        <Typography
                            fontSize={10}
                            color="text.secondary"
                            noWrap
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            <SensitiveInfoTypography>
                                {cutUID(sopInstanceUid, 4, 4)}
                            </SensitiveInfoTypography>
                        </Typography>
                        {structureSet.imageLabel && (
                            <Typography
                                fontSize={10}
                                color="text.secondary"
                                noWrap
                            >
                                <SensitiveInfoTypography>
                                    {structureSet.imageLabel}
                                </SensitiveInfoTypography>
                            </Typography>
                        )}
                    </Box>
                </Box>
            </PropertiesTooltip>
        </SelectableListItem>
    );
}
